import { DialogContent, DialogTitle } from "@mui/material";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import UKDialog from "@/common-components-src/components/UKDialog/index";

import styles from "./index.module.scss";

interface refundTipsModalProps {
  isOpen: boolean;
  closeHandler: () => void;
  content?: string;
}

const refundTipsModal: React.FC<refundTipsModalProps> = observer(
  ({ isOpen, closeHandler, content }) => {
    const { t } = useTranslation();

    let formatContent;
    try {
      formatContent = content && JSON.parse(content);
    } catch (e) {
      formatContent = content;
    }
    console.log(formatContent, "2323");

    return (
      <UKDialog
        open={isOpen}
        onClose={closeHandler}
        showCloseBtn={true}
        className={styles.refund_tips_modal}
      >
        <DialogTitle>{t("order.orderDetail.refundTipsModal.modalTitle")}</DialogTitle>
        <DialogContent>
          {formatContent && Array.isArray(formatContent) ? (
            formatContent.map(
              (
                item: {
                  title: string;
                  desc: string;
                },
                index: number,
              ) => {
                return (
                  <div className={styles.tips_wrap} key={index}>
                    <div className={styles.tips_title}>{item.title}</div>
                    <div className={styles.tips_content}>{item.desc}</div>
                  </div>
                );
              },
            )
          ) : (
            <div className={styles.tips_content}>{formatContent}</div>
          )}
        </DialogContent>
      </UKDialog>
    );
  },
);

export default refundTipsModal;
